import { getLanguage } from '@/lang/index'

// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle (title) {
  const hasKey = this.$te('route.' + title)

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t('route.' + title)

    return translatedTitle
  }
  return title
}

export function generateRole (title) {
  const hasKey = this.$te('role.' + title)

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t('role.' + title)

    return translatedTitle
  }
  return title
}

export function generatePlaceholder (title) {
  const hasKey = this.$te('placeholder.' + title)

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t('placeholder.' + title)

    return translatedTitle
  }
  return title
}

export function generateCnUs () {
  const lang = getLanguage()

  if (lang === 'en') {
    return 'en_US'
  } else if (lang === 'zh') {
    return 'zh_CN'
  }

  return 'zh_CN'
}

export function generateCalendar () {
  const lang = getLanguage()

  if (lang === 'en') {
    return 'en_us'
  } else if (lang === 'zh') {
    return 'zh_CN'
  }

  return 'zh_cn'
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js